import Vue from "vue";

Vue.filter('number', function (v, forceZero) {
    if (v === null || v === undefined || (forceZero !== true && v === 0)) return '';
    return new Intl.NumberFormat().format(v);
});